export default {
    upgrade: {
        title: '選擇適合您的方案',
        subtitle: '解鎖專業功能，提升您的生產力',
        pickYourPlan: '選擇方案',
        subscribeSuccess: '訂閱成功',
        contactSales: '請聯絡我們的銷售團隊以獲取企業解決方案。',
        enterpriseRestriction: '目前僅支援個人用戶訂閱付費方案，企業用戶如需使用請聯絡銷售團隊獲取專屬方案。',
        freeplanActivated: '基礎版已啟用',
        planNotFound: '未找到所選方案',
        alreadySubscribed: '您已經訂閱了此方案',
        priceIdNotConfigured: '該方案暫未配置支付資訊',
        paymentInitFailed: '支付初始化失敗，請重試',
        freeTrialCard: {
            title: '免費',
            titleSuffix: '試用 14 天',
            description: '無需信用卡',
            price: '包含 10,000 試用 Credits*',
            action: '開始免費試用',
            featuresTitle: '通常可用於：',
            features: {
                patentApplicationDraft: '≈ 1 份專利申請文件初稿',
                inventionDisclosures: '或≈ 2 份發明揭露書',
                officeActionResponses: '或≈ 2 份審查意見答覆',
                claimsDrawingsMore: '專利請求項、附圖等',
                efficiency: '專利撰寫速度最高提升 50% • 專利製圖速度最高提升 90%',
            },
        },
        maxPlan: {
            planName: 'Max',
            activeStatus: '生效中',
            cancelingStatus: '取消中',
            features: {
                unlimitedDrafting: '不限量建立專利撰寫文件',
                priorityWorkflow: '適合高頻撰寫的優先工作流',
            },
            billing: {
                title: '帳單與付款',
                cancelPlan: '取消方案',
                price: '價格',
                period: '計費週期',
                renewalDate: '續費日期',
                cancelDate: '取消日期',
                month: '月',
                year: '年',
            },
            cancel: {
                title: '取消 Max 方案',
                description: '取消後，您的 Max 方案會繼續生效到目前計費週期結束。',
                keepPlan: '保留方案',
                confirm: '確認取消',
                processing: '取消中...',
                otherPlaceholder: '請告訴我們原因',
                noSubscription: '未找到有效的 Max 訂閱。',
                success: '訂閱已取消，您的 Max 方案會繼續生效至 {date}。',
                failed: '取消訂閱失敗，請重試。',
                reasons: {
                    tooExpensive: '價格太貴',
                    missingFeatures: '缺少功能',
                    lowQuality: '品質較低',
                    switchedToAnotherService: '切換到其他服務',
                    other: '其他',
                },
            },
        },
        plans: {
            period: {
                monthly: ' / 月',
                yearly: ' / 年',
            },
            basic: {
                name: '基礎版',
                subtitle: '入門必備核心功能',
                price: '免費',
                description: '適合正在探索 AI 專利撰寫的發明人和專利律師。',
                button: '立即開始',
                features: {
                    patentDraftingAgents: '存取專利撰寫智慧體，包括',
                    limitedHiroPrompts: 'AI 編輯，可有限使用 Hiro prompts',
                },
            },
            pro: {
                name: 'Pro',
                subtitle: '專業人士的高級工具',
                description: '加速專利申請全流程工作流',
                button: '訂閱 Pro',
                moduleName: '專業版（月繳/年繳）',
                yearlySavings: '年繳享優惠',
                featuresHeader: '全球專利申請全流程撰寫輔助功能：',
                features: {
                    additionalHiroMessages: '額外 Hiro Copilot 對話次數',
                    fullDocumentExports: '完整文件匯出',
                    disclosure1Doc: '發明揭露文件生成 ({n}篇)',
                    application1Doc: '專利申請文件撰寫 ({n}篇)',
                    oar1Doc: '核駁意見答覆 ({n}篇)',
                },
            },
            max: {
                name: 'Max',
                subtitle: '高頻撰寫的不限量方案',
                description: '撰寫與審查答覆工作流不限量使用。',
                button: '訂閱 Max',
                moduleName: 'Max（月繳/年繳）',
                yearlySavings: '年繳享優惠',
                features: {
                    unlimitedPatentDraftingAgents: '專利撰寫智能體不限量使用',
                },
            },
            enterprise: {
                name: '企業版',
                subtitle: '為組織提供全面的智慧支援',
                price: '聯絡我們',
                description: '面向整個團隊或組織擴展專利營運能力。',
                button: '預約演示',
                featuresHeader: '包含 Max 全部功能，並額外提供：',
                features: {
                    teamUsageHeader: '團隊用量與管理',
                    teamPooledCredits: '團隊共享 credits，並支援自定義分配',
                    adminConsole: '用於帳單、用量和用戶管理的管理員控制台',
                    collaborationHeader: '協作',
                    sharedWorkspaces: '共享工作區和團隊專案',
                    teamWideIntelligence: '團隊級智慧能力分發',
                    governanceHeader: '治理與安全',
                    ssoSecurity: 'SSO 和企業級安全控制',
                    rolePermissions: '面向用戶和工作區的角色權限',
                    fileUploadControls: '文件上傳控制',
                    privateIncognito: '私密無痕模式',
                    serviceHeader: '服務與成功',
                    dedicatedSupport: '專屬客戶支援',
                    slaMonitoring: '99.9% SLA 和主動監控',
                },
                benefits: {
                    expandedSearch: '檢索量擴容',
                    humanInLoop: '人機協同校驗',
                    advancedEditor: '高級線上編輯器',
                    workspaceIntegration: '團隊工作空間整合',
                    professionalExport: '專業文件匯出',
                    evenMoreHiro: '更多 Hiro Copilot 對話次數',
                    ssoSecurity: 'SSO 單點登入與高級安全配置',
                    dedicatedSuccess: '專屬客戶成功經理',
                },
            },
            api: {
                name: 'Open platform',
                subtitle: '開發者優先的整合方案',
                price: '定制化報價',
                description: '將專利智慧嵌入您現有的基礎設施。',
                button: '取得 API Key',
                featuresHeader: '開發者能力：',
                features: {
                    apisHeader: '面向自定義工作流的 APIs',
                    dataAiApis: '覆蓋專利、生命科學、研發和市場情報的 300+ 數據 APIs 與 60+ AI agent APIs',
                    widgetsHeader: '可嵌入 UI Widgets',
                    dropInWidgets: '將圖表、洞察和 AI 工作流嵌入您的產品，無需重建',
                    mcpHeader: '面向企業 AI 的 MCP Servers',
                    mcpServers: '透過任何 MCP 相容用戶端連接可信的 PatSnap 工具，包括 Claude Desktop 和 Cursor',
                    skillsHeader: 'Agent Skills 與 SDKs',
                    agentSkillsSdks: '使用 LangChain、OpenClaw、CrewAI 等框架建立並編排工作流',
                    playgroundHeader: '互動式開發者 Playground',
                    developerPlayground: '在一個地方探索場景演示、測試 APIs、建立 widgets 並生成程式碼',
                },
            },
            features: {
                hiroMessages: 'Hiro Copilot 對話互動',
                disclosure: '發明揭露文件生成',
                application: '專利申請文件撰寫',
                oar: '核駁意見答覆',
                patentDrafting: '專利撰寫',
                disclosureUnlimited: '發明揭露文件生成（不限量）',
                patentDraftUnlimited: '專利申請文件撰寫（不限量）',
                oarDraftUnlimited: '核駁意見答覆（不限量）',
                templateInstructionStyle: '範本 / 指令 / 格式自定義',
                customerTemplateInstructionStyle: '自訂範本 / 指令 / 風格',
                exportWordDocuments: '將撰寫內容匯出為 Word 文件',
                wordWpsPlugin: '包含 Eureka Pro（$200）：完整使用所有 Eureka 智能體',
            },
        },
        billingCycle: {
            monthly: '月繳',
            yearly: '年繳',
            shortSaveAmount: '省 ${amount}',
            saveAmount: '年繳節省 ${amount}',
        },
        features: '方案功能',
        benefits: '權益',
        currentPlan: '目前方案',
        recommend: '最受歡迎',
        audienceTabs: {
            label: '定價對象',
            individual: '個人',
            teams: '團隊與企業',
        },
        comparison: {
            title: '對比方案',
            plans: {
                guest: '訪客',
                free: '基礎版',
                pro: 'Pro',
                max: 'Max',
                enterprise: '企業版',
            },
            categories: {
                agent: '核心 Agent',
                features: '其他功能',
                ai: 'AI 工具',
                security: '安全與管控',
                collaboration: '企業協作',
            },
            rows: {
                disclosure: '發明揭露文件生成',
                application: '專利申請文件撰寫',
                oar: '核駁意見答覆',
                templates: '範本',
                instructions: '指令',
                styles: '風格',
                draftingCenter: '撰寫中心',
                officePlugin: 'Word 插件（即將發佈）',
                aiChat: 'Hiro',
                chatLimitN: '{n} 次/天',
                chatLimit500: '500 次/天',
                moreUsage: '更高的次數',
                evenMoreUsage: '定制次數',
                createProject: '建立專案',
                exportProject: '匯出專案',
                sharedAssets: '範本/指令/風格共享',
                enterpriseManagement: '企業管理',
            },
        },
    },
    pricing: {
        payment: {
            creatingSession: '正在建立支付工作階段...',
            errors: {
                createSessionFailed: '建立支付工作階段失敗，請檢查當前帳號類型。',
                verifyFailed: '驗證支付狀態失敗',
                verificationFailed: '支付驗證失敗',
                verificationError: '驗證過程中發生錯誤',
                invalidCallback: '無效的支付回調',
                noPriceId: '價格資訊未配置',
            },
        },
    },
};
